import { LINK_ITEM_API, getLinkItemPostPath } from 'modules/stores/api/stores-api'
import {
  LinkItemUpdateType,
  LinkItemViewType,
} from 'modules/stores/store/content/link/types/link-interface'
import { usePublisherErrorHandler } from 'modules/stores/store/hooks/use-publisher-error-handler'
import { StoreId } from 'modules/stores/types/stores-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useLinkActions = () => {
  const { internalErrorHandler } = usePublisherErrorHandler()

  const { fetcher: postFetcher } = useFetch<RequestMethodsEnum.post, LinkItemViewType>({
    method: RequestMethodsEnum.post,
    unprocessableContentHandler: () => {},
    internalErrorHandler,
  })

  const { fetcher: putFetcher } = useFetch<RequestMethodsEnum.put, LinkItemViewType>({
    method: RequestMethodsEnum.put,
    unprocessableContentHandler: () => {},
    internalErrorHandler,
  })

  const { fetcher: deleteFetcher } = useFetch({
    method: RequestMethodsEnum.delete,
  })

  const createLink = (storeId: StoreId, data: LinkItemUpdateType) =>
    postFetcher(getLinkItemPostPath(storeId), data)

  const updateLink = (id: number, data: LinkItemUpdateType) =>
    putFetcher(`${LINK_ITEM_API}/${id}`, data)

  const deleteLink = (id: number) => deleteFetcher(`${LINK_ITEM_API}/${id}`)

  return { createLink, updateLink, deleteLink }
}
